/*@flow*/

export default function truthy(v: any): boolean {
  return v === 'true' || v === true;
}
